<router-outlet></router-outlet>
<ngx-spinner type="line-scale-pulse-out"></ngx-spinner>
